// 所有插件
import Vue from 'vue'
// import axios from 'axios'
import Cookie from 'js-cookie'
// echarts图表插件
import * as echarts from 'echarts'

// lodash插件
import findKey from 'lodash/findKey.js'
// 多语言
import VueI18n from 'vue-i18n'

// 日志插件
// import * as MITO from '@zyf2e/monitor-web'

Vue.prototype.$echarts = echarts
Vue.prototype.$Cookie = Cookie

// Vue.use(ElementUI, { locale })
Vue.use(VueI18n)
// Vue.use(MITO.MitoVue)
// MITO.init({
//   dsn: 'http://192.168.200.151:8087',
//   apikey: 'wikifx'
// })
Vue.config.errorHandler = function (err, vm, info) {
  // handle error
  // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
  // 只在 2.2.0+ 可用
  // console.log(err, 111, vm, 222, info)
  // if (process.env.NODE_ENV == 'development') return
  const param = {
    time: new Date(), // 请求时间
    level: 'info', // 报错等级info-严重；warn-警告
    type: 'javascript',
    message: err.message, // 报错内容
    page: vm && vm.$route && vm.$route.fullPath,
    CountryCode: vm && vm.$store && vm.$store.state && vm.$store.state.CountryCode, // header国家
    LanguageCode: vm && vm.$store && vm.$store.state && vm.$store.state.LanguageCode // headers语言
  }
  console.log(param, 999)
  // axios.post(vm.$store.state.loghost, param)
}

VueI18n.prototype.translation = function (value) {
  const zh = require('~/static/languages/TXT_zh-CN.json')
  const val = findKey(zh, function (o) {
    return o == value
  })
  if (!val) {
    return value + '(未翻译)'
  }
  return this.$t(val)
}

export default ({ app, store, $axios, $cookies }) => {
  app.i18n = new VueI18n({
    silentTranslationWarn: true,
    locale: store.state.LanguageCode,
    fallbackLocale: 'en',
    messages: {
      'zh-cn': require('~/static/languages/TXT_zh-CN.json'),
      ar: require('~/static/languages/TXT_ar.json'),
      en: require('~/static/languages/TXT_en.json'),
      de: require('~/static/languages/TXT_de.json'),
      es: require('~/static/languages/TXT_es.json'),
      fil: require('~/static/languages/TXT_fil.json'),
      fr: require('~/static/languages/TXT_fr.json'),
      hi: require('~/static/languages/TXT_hi.json'),
      id: require('~/static/languages/TXT_id.json'),
      it: require('~/static/languages/TXT_it.json'),
      ja: require('~/static/languages/TXT_ja.json'),
      ko: require('~/static/languages/TXT_ko.json'),
      ms: require('~/static/languages/TXT_ms.json'),
      pt: require('~/static/languages/TXT_pt.json'),
      ru: require('~/static/languages/TXT_ru.json'),
      th: require('~/static/languages/TXT_th.json'),
      vi: require('~/static/languages/TXT_vi.json'),
      zh: require('~/static/languages/TXT_zh.json'),
      'zh-hk': require('~/static/languages/TXT_zh-HK.json'),
      'zh-tw': require('~/static/languages/TXT_zh-TW.json')
    }
  })

  Vue.prototype.$v = app.i18n.translation
}
